import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Separator } from "@/components/ui/separator";
import { ShieldCheck } from "lucide-react";

const Privacy = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />

      <main className="flex-grow pt-16">
        {/* Hero section */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-brand-50 to-white"></div>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold mb-6">
                Politika e Privatësisë
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                Mënyra se si mbrojmë të dhënat tuaja personale dhe respektojmë
                privatësinë tuaj.
              </p>
              <div className="flex justify-center items-center text-sm text-gray-500">
                <span>Përditësuar së fundmi: 13 Mars, 2025</span>
              </div>
            </div>
          </div>
        </section>

        {/* Privacy content */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
                <div className="flex items-center mb-6">
                  <ShieldCheck size={24} className="text-brand-500 mr-3" />
                  <h2 className="text-2xl font-bold">
                    Politika e Privatësisë së TreguIm
                  </h2>
                </div>

                <div className="prose prose-stone max-w-none">
                  <p>
                    Në TreguIm, ne vlerësojmë privatësinë tuaj dhe jemi të
                    përkushtuar të mbrojmë të dhënat tuaja personale. Kjo
                    Politikë e Privatësisë shpjegon se si mbledhim, përdorim dhe
                    mbrojmë informacionin tuaj kur përdorni platformën tonë.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    1. Informacioni që mbledhim
                  </h3>
                  <p>
                    Ne mund të mbledhim llojet e mëposhtme të informacionit:
                  </p>
                  <ul>
                    <li>
                      <strong>Të dhënat personale:</strong> Emri, adresa e-mail,
                      numri i telefonit, adresa fizike.
                    </li>
                    <li>
                      <strong>Informacioni i profilit:</strong> Fotoja e
                      profilit, biografia, vendndodhja.
                    </li>
                    <li>
                      <strong>Të dhënat e transaksionit:</strong> Informacioni
                      në lidhje me produktet që shitni ose kërkoni të blini.
                    </li>
                    <li>
                      <strong>Të dhënat e përdorimit:</strong> Informacioni
                      rreth mënyrës se si ndërveproni me platformën tonë.
                    </li>
                    <li>
                      <strong>Të dhënat e pajisjes:</strong> Informacioni rreth
                      pajisjes që përdorni për të hyrë në platformën tonë.
                    </li>
                  </ul>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    2. Si e përdorim informacionin tuaj
                  </h3>
                  <p>
                    Ne përdorim informacionin tuaj për qëllimet e mëposhtme:
                  </p>
                  <ul>
                    <li>Për të ofruar dhe përmirësuar shërbimet tona.</li>
                    <li>
                      Për të lehtësuar komunikimin midis blerësve dhe shitësve.
                    </li>
                    <li>
                      Për të personalizuar përvojën tuaj në platformën tonë.
                    </li>
                    <li>
                      Për të zbuluar dhe parandaluar aktivitetet mashtruese ose
                      të paligjshme.
                    </li>
                    <li>
                      Për t'ju dërguar informacione lidhur me platformën,
                      shërbimet, dhe përditësimet.
                    </li>
                  </ul>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    3. Ndarja e informacionit tuaj
                  </h3>
                  <p>Ne mund të ndajmë informacionin tuaj me:</p>
                  <ul>
                    <li>
                      <strong>Përdoruesit e tjerë:</strong> Kur listoni një
                      produkt ose kontaktoni një shitës, disa informacione si
                      emri juaj i përdoruesit dhe fotoja e profilit mund të jenë
                      të dukshme për përdoruesit e tjerë.
                    </li>
                    <li>
                      <strong>Ofruesit e shërbimeve:</strong> Ne punojmë me palë
                      të treta që na ndihmojnë të ofrojmë shërbimet tona.
                    </li>
                    <li>
                      <strong>Partnerët e biznesit:</strong> Ne mund të ndajmë
                      informacione me partnerët tanë të biznesit për të ofruar
                      shërbime ose funksionalitete të caktuara.
                    </li>
                    <li>
                      <strong>Autoritet ligjore:</strong> Ne mund të ndajmë
                      informacione nëse kërkohet me ligj ose për të mbrojtur të
                      drejtat tona ose të përdoruesve tanë.
                    </li>
                  </ul>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    4. Ruajtja dhe siguria e të dhënave
                  </h3>
                  <p>
                    Ne marrim masa të arsyeshme teknike dhe organizative për të
                    mbrojtur informacionin tuaj nga humbja, keqpërdorimi dhe
                    qasja e paautorizuar. Megjithatë, asnjë sistem sigurie nuk
                    është 100% i sigurt, dhe ne nuk mund të garantojmë sigurinë
                    absolute të informacionit tuaj.
                  </p>
                  <p>
                    Ne do të ruajmë informacionin tuaj për aq kohë sa është e
                    nevojshme për qëllimet e përshkruara në këtë Politikë ose
                    siç kërkohet nga ligji.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    5. Cookies dhe teknologji të ngjashme
                  </h3>
                  <p>
                    Ne përdorim cookies dhe teknologji të ngjashme për të
                    mbledhur informacion rreth aktivitetit tuaj në platformën
                    tonë, për të mbajtur mend preferencat tuaja dhe për të
                    personalizuar përvojën tuaj. Ju mund të menaxhoni
                    preferencat tuaja të cookies përmes konfigurimeve të
                    shfletuesit tuaj.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    6. Të drejtat tuaja të privatësisë
                  </h3>
                  <p>
                    Në varësi të ligjeve të aplikueshme, ju mund të keni të
                    drejta të caktuara lidhur me të dhënat tuaja personale, duke
                    përfshirë:
                  </p>
                  <ul>
                    <li>Të drejtën për të qasur të dhënat tuaja personale.</li>
                    <li>
                      Të drejtën për të korrigjuar të dhënat tuaja personale.
                    </li>
                    <li>Të drejtën për të fshirë të dhënat tuaja personale.</li>
                    <li>
                      Të drejtën për të kufizuar përpunimin e të dhënave tuaja
                      personale.
                    </li>
                    <li>
                      Të drejtën për të kundërshtuar përpunimin e të dhënave
                      tuaja personale.
                    </li>
                    <li>
                      Të drejtën për të transferuar të dhënat tuaja personale.
                    </li>
                  </ul>
                  <p>
                    Për të ushtruar këto të drejta, ju lutemi na kontaktoni në
                    privacy@treguim.org.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    7. Ndryshimet në Politikën e Privatësisë
                  </h3>
                  <p>
                    Ne mund të përditësojmë këtë Politikë Privatësie kohë pas
                    kohe. Nëse bëjmë ndryshime materiale, do t'ju njoftojmë duke
                    postuar politikën e re në platformën tonë ose duke ju
                    dërguar një njoftim.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">8. Kontakt</h3>
                  <p>
                    Nëse keni pyetje ose shqetësime rreth Politikës sonë të
                    Privatësisë ose praktikave tona të të dhënave, ju lutemi na
                    kontaktoni në:
                  </p>
                  <p>
                    Email: privacy@treguim.org
                    <br />
                    Adresa: Tiranë, Shqipëri
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
